import * as React from 'react';
import Box from '@mui/material/Box';
import { isAutogeneratedRow } from '@mui/x-data-grid-premium';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStaticFlag = typeof DISABLE_CHANCE_RANDOM !== 'undefined' && DISABLE_CHANCE_RANDOM;
const laosFlag = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600">
  <path fill="#ce1126" d="M0 0h900v600H0z" />
  <path fill="#002868" d="M0 150h900v300H0z" />
  <circle r="120" cy="300" cx="450" fill="#fff" />
</svg>
`;
const staticFlagURI = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(laosFlag)}`;
const Country = /*#__PURE__*/React.memo(function Country(props) {
  const {
    value
  } = props;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      '&  > img': {
        mr: 0.5,
        flexShrink: 0,
        width: '20px'
      }
    },
    children: [/*#__PURE__*/_jsx("img", {
      loading: "lazy",
      width: "20",
      src: useStaticFlag ? staticFlagURI : `https://flagcdn.com/w20/${value.code.toLowerCase()}.png`,
      srcSet: useStaticFlag ? undefined : `https://flagcdn.com/w40/${value.code.toLowerCase()}.png 2x`,
      alt: ""
    }), /*#__PURE__*/_jsx(Box, {
      component: "span",
      sx: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      children: value.label
    })]
  });
});
if (process.env.NODE_ENV !== "production") Country.displayName = "Country";
export function renderCountry(params) {
  if (params.value == null) {
    return '';
  }
  if (params.aggregation || isAutogeneratedRow(params.row)) {
    return params.value;
  }
  return /*#__PURE__*/_jsx(Country, {
    value: params.value
  });
}